import { useNavigate } from 'react-router-dom';
import PageContainer from '../../components/PageContainer/PageContainer';
import { Checkmark } from '@brainpool/icon-pack';
import { Avatar, Box, Button, Stack, Typography, useTheme } from '@mui/material';
import { goToPage } from '../../utils/commonFunctions';

export function PaymentSuccess() {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <PageContainer testid="payment-success-page" boxed>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          py: 4,
        }}
      >
        <Box
          className="tunedd-page-content"
          sx={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <Avatar
            sx={{
              bgcolor: 'transparent',
              width: 80,
              height: 80,
              border: `3px solid ${theme.palette.success.main}`,
            }}
          >
            <Checkmark fill={theme.palette.success.main} size={48} />
          </Avatar>
          <Typography variant="h1">Payment Successful</Typography>
          <Typography variant="body2">
            Your subscription is now active. You can start creating and managing your projects right
            away.
          </Typography>
          <Typography variant="body1">
            We’ve received your payment. A detailed receipt has been sent to your email by Stripe.
          </Typography>
        </Box>
      </Box>
      <Stack direction="row" justifyContent="center" gap={2}>
        <Button variant="contained" color="primary" onClick={() => goToPage('/projects', navigate)}>
          View Projects
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => goToPage('/new-project', navigate)}
        >
          Add Project
        </Button>
      </Stack>
    </PageContainer>
  );
}

export default PaymentSuccess;
